.container {
  width: 100%;
  background-color: var(--static-background-standard);
  padding: 1.25rem;
  height: 100%;
  border-radius: 12px;
}

.loadingContainer {
    padding: 1rem;
    width: 100%;
    background-color: var(--static-background-standard);
    border-radius: 0.5rem;
    height: 100%;
}

.title {
  font-size: var(--fs-small);
  font-weight: 500;
  color: var(--static-text-standard);
  margin-bottom: 0.5rem;
}

.value {
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--static-text-strong);
  line-height: 32px;
  margin-bottom: 2rem;
}

.chartContainer {
  width: 100%;
  position: relative;
  height: 100%;
}